import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FileText, Gauge, Image, LogOut, Newspaper, Package, Users } from "lucide-react";
import { useAuth } from "./AuthContext";

const links = [
  { to: "/admin/dashboard", label: "Dashboard", icon: Gauge },
  { to: "/admin/pages", label: "Pages", icon: FileText },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/media", label: "Media", icon: Image },
  { to: "/admin/users", label: "Users", icon: Users },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-board)] text-ink md:grid md:grid-cols-[250px_1fr]">
      <aside className="border-r border-[var(--grid-line)] bg-paper p-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-faint">Portfolio CMS</p>
        <h1 className="font-display text-2xl mt-1">Admin</h1>
        <p className="mt-2 text-sm text-ink-soft">{user?.name} · {user?.role}</p>
        <nav className="mt-7 space-y-1">
          {links.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 text-sm border transition ${isActive ? "border-ink bg-ink text-paper" : "border-transparent hover:border-[var(--paper-edge)]"}`}
            >
              <Icon size={15} /> {label}
            </NavLink>
          ))}
        </nav>
        <button
          onClick={async () => {
            await logout();
            navigate("/admin/login");
          }}
          className="mt-8 inline-flex items-center gap-2 text-sm text-accentRed"
        >
          <LogOut size={15} /> Logout
        </button>
      </aside>
      <main className="p-5 md:p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
